import type {
  UserGetLoyaltyTransactionHistoryParams,
  UserListReferralsParams,
} from '../api'
import { api } from '../api'

const getReferralCodes = async () => {
  return await api.v1.userGetReferralCodes()
}

const getReferralList = async (params: UserListReferralsParams) => {
  return await api.v1.userListReferrals(params)
}

const getLoyaltyTransactionHistory = async (
  params: UserGetLoyaltyTransactionHistoryParams,
) => {
  return await api.v1.userGetLoyaltyTransactionHistory(params)
}

const getLoyaltyMissions = async () => {
  return await api.v1.userGetLoyaltyMissions()
}

const getLoyaltyPortfolio = async () => {
  return await api.v1.userGetLoyaltyPortfolio()
}

export default {
  getReferralCodes,
  getReferralList,
  getLoyaltyTransactionHistory,
  getLoyaltyMissions,
  getLoyaltyPortfolio,
}
